import React from 'react';
import MyAccountOverview from '../components/MyAccountOverview';
const MyAccountOverviewContainer = ({userProfile,plans}) => {
  return (<MyAccountOverview userProfile={userProfile} plans={plans} />)
};

export default MyAccountOverviewContainer;
